import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";
import { IOrganisationIndex } from "../../organisations/model/OrganisationIndex";
import { ICourtCase } from "./CourtCase";
import { ISummaryTranslation } from "../../core/model/translations/SummaryTranslation";

export interface TCaseLawDocument {
  id: number;
  searchId: string;
  summary: string;
  status: string;
  notes: string;
  documentTypeId: number;
  organisationId: number;
  organisationIndexId: number;
  organisationIndex: IOrganisationIndex;
  courtCaseList: ICourtCase[];
  valid: boolean;
  caseLawDocDate: Date;
  invalidatedBy: number;
  invalidationReason: string;
  summaryTranslations: ISummaryTranslation[];
}

export interface ICaseLawDocument extends TCaseLawDocument {}

const CaseLawDocument = Model((model: TCaseLawDocument): ICaseLawDocument => {
  const _value: TCaseLawDocument = Object.assign({}, model);

  let _model = {
    get id() {
      return _value.id;
    },
    set id(value) {
      _value.id = value;
    },
    get summary() {
      return _value.summary;
    },
    set summary(value) {
      _value.summary = value;
    },
    get status() {
      return _value.status;
    },
    set status(value) {
      _value.status = value;
    },
    get notes() {
      return _value.notes;
    },
    set notes(value) {
      _value.notes = value;
    },
    get valid() {
      return _value.valid;
    },
    set valid(value) {
      _value.valid = value;
    },
    get documentTypeId() {
      return _value.documentTypeId;
    },
    set documentTypeId(value) {
      _value.documentTypeId = value;
    },
    get organisationIndexId() {
      return _value.organisationIndexId;
    },
    set organisationIndexId(value) {
      _value.organisationIndexId = value;
    },
    get organisationIndex() {
      return _value.organisationIndex;
    },
    set organisationIndex(value) {
      _value.organisationIndex = value;
    },
    get organisationId() {
      return _value.organisationId;
    },
    set organisationId(value) {
      _value.organisationId = value;
    },
    get caseLawDocDate() {
      return _value.caseLawDocDate;
    },
    set caseLawDocDate(value) {
      _value.caseLawDocDate = value;
    },
    get courtCaseList() {
      return _value.courtCaseList;
    },
    set courtCaseList(value) {
      _value.courtCaseList = value;
    },
    get invalidatedBy() {
      return _value.invalidatedBy;
    },
    set invalidatedBy(value) {
      _value.invalidatedBy = value;
    },
    get invalidationReason() {
      return _value.invalidationReason;
    },
    set invalidationReason(value) {
      _value.invalidationReason = value;
    },
    get summaryTranslations() {
      return _value.summaryTranslations;
    },
    set summaryTranslations(value) {
      _value.summaryTranslations = value;
    },
    get searchId() {
      return _value.searchId;
    },
    set searchId(value) {
      _value.searchId = value;
    }
  };

  return ValidatableObject<ICaseLawDocument>(_model);
});

export default CaseLawDocument;
